export default {
  authed: () => import("/home/runner/work/ticketco-portal/ticketco-portal/layouts/authed.vue"),
  default: () => import("/home/runner/work/ticketco-portal/ticketco-portal/layouts/default.vue"),
  unauthed: () => import("/home/runner/work/ticketco-portal/ticketco-portal/layouts/unauthed.vue")
}